export const HOME_URL = "/home";
export const SIGNIN_URL = "/auth/signin";
export const SIGNUP_URL = "/auth/signup";

export const APP_NAME = "Your App";
export const APP_DESCRIPTION = "";
export const PREVIEW_USER_ID = "f5bc5f62-f9c1-434f-8f3b-d199dc579569";